"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lang = void 0;
const Lang = {
    MSG_SUCCESS: '成功:',
    MSG_ERROR: '错误: ',
    HELP_MESSAGE: '--h: 帮助信息',
    CORE_STRTUP: 'Coda CLI正在启动',
    CORE_STRTUP_DONE: 'Coda CLI启动完成',
    CORE_CHECKING_UPDATE: 'Coda CLI正在检查更新...',
    CORE_LATEST_VERSION: 'Coda CLI是最新版本.',
    CORE_PACKAGES_FOUND_NEW_VERSION: 'Coda CLI依赖包有新版本:',
    CORE_UPDATE_PACKAGES: 'Coda CLI即将更新依赖包,不要关闭当前命令窗口.',
    CORE_UPDATE_READY: 'Coda CLI有新版本,即将打开新的命令窗口进行版本升级.',
    CORE_LINUX_INPUT_ROOT_USER_PASSWORD: '注意观察命令行窗口：Linux用户需要输入root密码.',
    EXSITED: '已存在',
    NOT_EXSITED: '不存在',
    NAME_NO_WHITESPACE: '文件名不能有空格',
    NAME_NO_SPECIAL_CHARACTER: '文件名仅支持"-"或"_"特殊符号',
    NAME_LOWERCASE: '文件名必须小写',
    NO_COMMAND: '没有该名称的命令',
    MEAN_SUCH: '你的意思是:',
    COMMAND_LENGTH_TOO_LONG: '命令单词长度太长',
    CLI_VOLIDATE_CMD_SUCCESS: 'Coda CLI校验命令成功',
};
exports.Lang = Lang;
